// Ramki User.com: lista produktów z User.com, karty z sections/user-reco-cards.liquid
(() => {
  function predict(api, endpoint, body) {
    return fetch(api + '/predictions/' + endpoint + '/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
      signal: AbortSignal.timeout?.(3000),
    })
      .then((res) => {
        if (!res.ok) throw new Error('User.com ' + endpoint + ': ' + res.status);
        return res.json();
      })
      .then((data) => data.recommended_products || []);
  }

  async function load(el) {
    const d = el.dataset;
    const userKey = d.personalize === 'true' && (document.cookie.match(/(?:^|; )__ca__chat=([^;]*)/) || [])[1];
    // extra_data: 0 = bez produktów spoza segmentu
    const extra = d.extraData ? { extra_data: Number(d.extraData) } : {};
    const segment = { limit: Number(d.limit), segment_id: Number(d.segment), ...extra };

    const [pinned, main] = await Promise.all(
      [
        Number(d.extraSegment)
          ? predict(d.api, 'predict', { custom_ids: [1], limit: Number(d.extraLimit), segment_id: Number(d.extraSegment), ...extra })
          : [],
        userKey
          ? predict(d.api, 'predict-for-user', { user_key: decodeURIComponent(userKey), ...segment })
          : predict(d.api, 'predict', { custom_ids: [1], ...segment }),
      ].map((request) => Promise.resolve(request).catch((err) => (console.error('[User.com]', err), [])))
    );

    // handle (Liquid szuka po nim produktów) => wariant do GA, 0 = brak
    const products = new Map();
    pinned.concat(main).forEach((item) => {
      const handle = ((item.product_url || '').match(/\/products\/([^/?#]+)/) || [])[1];
      const variant = (item.attributes || []).find((attr) => attr.name === 'shopify_product_variant_id');
      if (handle && !products.has(handle)) products.set(handle, Number(variant && variant.value) || 0);
    });
    if (!products.size) throw new Error('User.com: brak produktów');

    const q = [...products.keys()].join(',') + '|' + [...products.values()].join(',');
    const res = await fetch(Shopify.routes.root + 'search?q=' + encodeURIComponent(q) + '&section_id=user-reco-cards');
    const cards = [...new DOMParser().parseFromString(await res.text(), 'text/html').querySelectorAll('[data-list-item]')];
    if (!cards.length) throw new Error('Shopify: brak dostępnych produktów');

    cards.forEach((card) => (card.className = d.slideClass));
    el.replaceChildren(...cards);
    el.closest('.swiper')?.swiper?.update();
    window.trackList?.(el);

    if (d.popup) {
      setTimeout(() => {
        document.getElementById('PopupModal-' + d.popup)?.show();
        sessionStorage.setItem('modal-' + d.popup, '1');
      }, 10000);
    }
  }

  function init(root) {
    root.querySelectorAll('[data-user-reco]:not([data-ready])').forEach((el) => {
      el.dataset.ready = '';
      if (el.dataset.popup && sessionStorage.getItem('modal-' + el.dataset.popup) === '1') return;
      load(el).catch((err) => {
        console.error('[User.com]', err);
        // zostaje fallback z Liquid, a bez niego ukrywamy ramkę
        if (el.childElementCount) window.trackList?.(el);
        else el.closest('.featured-collection')?.style.setProperty('display', 'none');
      });
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
